/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListCatalog } from "../../funcs/llmModelsListCatalog.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$llmModelsListCatalog: ToolDefinition = {
  name: "llm-models-list-catalog",
  description: `List the organization's model catalog

Lists all BYO, serving, and cluster-access definitions with activation state, blocker, health, and price preview.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await llmModelsListCatalog(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
